const Keys = {
  googleVision: "",
  vapid: "",
  firebase: "",
  // ClientID: '84771f27-f933-4f43-baa0-2e803a124abc',
  ClientID: "1a427d8b-0aed-44c6-9003-6e208466ac97",
  TenantID: "3485b963-82ba-4a6f-810f-b5cc226ff898",
  DivisionID: "03E8466B-7EEC-4C57-849A-79A2B78BECBA",
  SharePoint_BaseUrl:
    "binusianorg.sharepoint.com/sites/SSG6-C2-BMHelpDesk-PROD/CDNASSETS/",
  Public_CDN: "https://api.apps.binus.ac.id/gahelpdesk/",
  GAMeasurementID: "G-23BWC8Q2RQ",
};

export default Keys;
